<template>
  <div class="container content">

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Long Form
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">
      <div class=" card-header">
        <div class="card-header-title">
          Property Address
        </div>
        <div class="level-right is-small">
          <a
            @click="goToProperty()"
            style="padding-left: 20px"
          >
            <i class="fas fa-arrow-left"></i>
            return to property&nbsp;&nbsp;</a>
        </div>
      </div>
      <div class="card-content">
        <div class="columns">

          <div class="column">

            <div v-if="$store.state.property.multifamilyAttributes.propertyName">
              <h2>{{ $store.state.property.multifamilyAttributes.propertyName }}</h2>
              <h4>{{ $store.state.property.address }}</h4>
              <h4>{{ $store.state.property.city }}, {{ $store.state.property.state }} {{ $store.state.property.zip }}</h4>
            </div>
            <div v-if="!$store.state.property.multifamilyAttributes.propertyName">
              <h3>{{ $store.state.property.address }}</h3>
              <h4>{{ $store.state.property.city }}, {{ $store.state.property.state }} {{ $store.state.property.zip }}</h4>
            </div>
          </div>

          <div class="column">
            <div class="content"></div>
            <div class="level">
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Units</p>
                  <p class="subtitle">&nbsp;{{ $store.state.property.multifamilyAttributes.units }}&nbsp;</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Year Built</p>
                  <p class="subtitle">&nbsp;{{ $store.state.property.multifamilyAttributes.yearBuilt }}&nbsp;</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Class</p>
                  <p class="subtitle">&nbsp;{{ $store.state.property.multifamilyAttributes.propertyClass }}&nbsp;</p>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="card">
      <section class="hero is-info">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Worksheet
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">
      <div
        class="card-content"
        @input="setChanged()"
      >

        <div class="tile is-ancestor">

          <div class="tile is-parent is-vertical">

            <div class="tile is-child box">

              <p class="title">Rents</p>

              <p class="subtitle">Scheduled Rents</p>

              <table class="is-size-7">
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Scheduled Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Monthly $</td>
                  <td class="header align-center">Annually $</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.longform.inputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.currentRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft | number(0) }}</td>
                  <td class="align-center">{{ line.currentPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.currentMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.currentAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalUnitCount }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalCurrentRent | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalSqft | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalCurrentPricePerSqft | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalCurrentMonthly | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalCurrentAnnual | currency(0) }}</td>
                </tr>

              </table>

              <p class="subtitle">Proforma Rents</p>

              <table class="is-size-7">
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Proforma Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Monthly $</td>
                  <td class="header align-center">Annually $</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.longform.inputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.proformaRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft }}</td>
                  <td class="align-center">{{ line.proformaPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.proformaMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.proformaAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalUnitCount }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalProformaRent | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalSqft | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalProformaPricePerSqft | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalProformaMonthly | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.longform.inputs.totalProformaAnnual | currency(0) }}</td>
                </tr>

              </table>

            </div>

          </div>

          <div class="tile is-parent is-vertical">

            <div class="tile is-child box">

              <p class="title">Mortgage Information</p>

              <table class="is-size-7">
                <tr>
                  <td>Loan Amount $</td>
                  <td class="align-right">{{ $store.state.longform.inputs.loanAmount | currency(0) }}</td>
                </tr>
                <tr>
                  <td>Interest Rate %</td>
                  <td class="align-right">{{ $store.state.longform.inputs.interestRatePercent | percent(2) }}</td>
                </tr>
                <tr>
                  <td>Term in Years</td>
                  <td class="align-right">{{ $store.state.longform.inputs.termInYears }}</td>
                </tr>
                <tr>
                  <td>Interest Only Period in Years</td>
                  <td class="align-right">{{ $store.state.longform.inputs.interestOnlyPeriodInYears | number(2) }}</td>
                </tr>
              </table>

            </div>

            <div class="tile is-child box">

              <p class="title">Income & Expense Increases</p>

              <table
                class="is-size-7"
                style="margin-bottom: 4em"
              >
                <thead>
                  <tr>
                    <th>Type of Increase</th>
                    <th style="text-align: center">Year 2</th>
                    <th style="text-align: center">Year 3</th>
                    <th style="text-align: center">Year 4</th>
                    <th style="text-align: center">Year 5</th>
                    <th style="text-align: center">Year 6</th>
                  </tr>
                </thead>
                <tbody>

                  <tr>
                    <td>Income Increase</td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.incomeIncreaseYear2"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.incomeIncreaseYear3"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.incomeIncreaseYear4"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.incomeIncreaseYear5"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.incomeIncreaseYear6"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>

                  </tr>

                  <tr>
                    <td>Expense Increase</td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.expenseIncreaseYear2"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.expenseIncreaseYear3"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.expenseIncreaseYear4"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.expenseIncreaseYear5"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                    <td class="align-right">
                      <div class="level-right">
                        <b-input
                          type="number"
                          v-model="$store.state.longform.inputs.expenseIncreaseYear6"
                          @focus="$event.target.select()"
                          @input="calculate()"
                          size="is-small"
                          style="width: 5em"
                        ></b-input>%
                      </div>
                    </td>
                  </tr>

                </tbody>

              </table>

            </div>

          </div>

        </div>

        <div class="tile is-parent is-vertical box">

          <p class="title">Long Form Calculations</p>

          <div class="specialdiv">
            <table class="is-size-7">

              <thead>
                <tr>
                  <th></th>
                  <th
                    style="text-align: center"
                    nowrap
                    v-for="nth in 21"
                    :key="nth"
                  >{{ $store.state.longform.monthNames[nth-1] }}<br>{{ $store.state.longform.columnHeaders[nth-1] }}
                  </th>
                </tr>
              </thead>
              <tbody>

                <LongFormDataRow
                  :rowdata=$store.state.longform.grossPotentialRent
                  label="Gross Potential Rent"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.gtol
                  label="GTOL"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.newMoveInConcession
                  label="New Move-in Concession"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.vacancy
                  label="Vacancy"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.badDebt
                  label="Bad Debt"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.rentalIncome
                  label="Rental Income"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.otherIncome
                  label="Other Income"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.totalIncomeDollar
                  label="Total Income"
                  class="subtotal1"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.totalIncomePercent
                  label=""
                  :percentDecimals="0"
                />

                <LongFormDataRowEmpty />

                <tr>
                  <th style="font-style: italic">Operating Expenses</th>
                  <td
                    colspan="16"
                    style="border-right: 2px solid #000;"
                  ></td>
                  <td colspan="5"></td>
                </tr>

                <LongFormDataRow
                  :rowdata=$store.state.longform.taxes
                  label="Taxes"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.salariesAndPersonnel
                  label="Salaries and Personnel"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.repairAndMaintenance
                  label="Repair and Maintenance"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.managementFees
                  label="Management Fees"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.contractServices
                  label="Contract Services"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.utilities
                  label="Utilities"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.administrative
                  label="Administrative"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.insurance
                  label="Insurance"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.marketing
                  label="Marketing"
                />

                <LongFormDataRow
                  v-for="customItem in $store.state.longform.customList"
                  :key="customItem.name"
                  :rowdata=customItem.row
                  :label=customItem.name
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.carriedOver
                  label="Delete - carried over"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.totalOperatingExpenses
                  label="TOTAL OPERATING EXPENSES"
                  class="subtotal1"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.noi
                  label="NOI"
                  class="subtotal2"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.utilityAndPayrollDeposits
                  label="Utility & Payroll Deposits"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.mortgageInterest
                  label="Mortgage Interest"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.principal
                  label="Principal"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.reserves
                  label="Reserves"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.assetManagement
                  label="Asset Management"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.leadInvestorCompensation
                  label="Lead Investor Compensation"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.netCash
                  label="Net Cash"
                  class="subtotal2"
                />

                <LongFormDataRowEmpty />

                <LongFormDataRowEmpty />

                <LongFormDataRow
                  :rowdata=$store.state.longform.beginningOccupancy
                  label="Beginning Occupancy"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.moveIns
                  label="Move Ins"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.moveOuts
                  label="Move Outs"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.endingOccupancyCount
                  label="Endng Occupancy"
                />

                <LongFormDataRow
                  :rowdata=$store.state.longform.endingOccupancyPercent
                  label=""
                  :percentDecimals="0"
                />

              </tbody>
            </table>
          </div>

        </div>

      </div>

    </div>

    <p class="disclaimer">DISCLAIMER: This represents an estimated sale price for this property. It is not the same as the opinion of value in an appraisal developed by a licensed appraiser under the Uniform Standards of Professional Appraisal Practice. LS Realty Advisors, Inc., and/or Lifestyles Realty, Inc., and/or Lifestyles Unlimited, Inc. have not verified the information and make no guarantee, warranty, or representation. This broker price opinion was either filled out by a Lifestyles representative or the potential buyer or other. Further investigation may be necessary as more information is made available. When more information is available the opinion may substantially change; the reader should be aware of the limited scope of this opinion.</p>

    <div
      class="notices is-bottom is-size-7"
      v-show="changed"
    >
      <div
        class="snackbar is-success is-bottom-left"
        style="margin-bottom: -2em;margin-left: -2em"
      >
        <p
          class="text"
          style="margin-bottom: 0em;"
        >Your Long Form has unsaved changes, click</p>
        <div class="action">
          <button
            class="button is-success is-small"
            @click="updateLongform()"
          >Save</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import Financial from "formulajs";
import Moment from "moment";
import LongFormDataCell from "@/components/properties/evaluations/multifamily/LongFormDataCell.vue";
import LongFormDataRow from "@/components/properties/evaluations/multifamily/LongFormDataRow.vue";
import LongFormDataRowEmpty from "@/components/properties/evaluations/multifamily/LongFormDataRowEmpty.vue";

export default {
  components: {
    Financial,
    Moment,
    LongFormDataCell,
    LongFormDataRow,
    LongFormDataRowEmpty
  },

  props: {
    property_id: undefined
  },

  data() {
    return {
      changed: false
    };
  },

  methods: {
    removeLine(customList, lineId) {
      if (!this.blockRemoval) {
        customList.splice(lineId, 1);
      }
      this.setChanged();
      this.calculate();
    },

    addLine(customList) {
      let checkEmptyLines = customList.filter(line => line.name === null);
      if (checkEmptyLines.length >= 1 && customList.length > 0) return;
      customList.push({
        name: null,
        amount: null
      });
      this.setChanged();
      this.calculate();
    },

    async updateLongform() {
      this.changed = false;

      this.calculate(false);

      var propertyId = this.$route.params.property_id;
      var longformId = this.$route.params.longform_id;
      var longform = this.$store.state.longform;
      console.log("TCL: updateLongform -> longform", longform);
      await this.$store
        .dispatch("updateLongform", {
          propertyId,
          longformId,
          longform
        })
        .then(() => {
          this.$store.state.liberatorSuccess = "Long Form is saved!";
        })
        .catch(() => {
          this.changed = true;
        });
    },

    goToProperty() {
      this.$router.push({
        name: "PropertyDetails",
        params: {
          property_id: this.$store.state.property.id
        }
      });
    },

    async setChanged() {
      if (this.changed == false) {
        this.changed = true;
      }
    },

    calculate(delay = true) {
      let interval = 500;
      this.lastCalculateRequest = new Moment();

      // Queue up the calculation.
      if (delay) {
        setTimeout(() => {
          let now = new Moment();
          let lastCalc = this.lastCalculateRequest;
          let diff = now - lastCalc;
          if (diff >= interval)
            for (var index = 0; index < 3; index++) this.doCalculations();
        }, interval);
      } else for (var index = 0; index < 3; index++) this.doCalculations();
    },

    getValue(input) {
      if (parseFloat(input)) return parseFloat(input);
      else return 0;
    },

    floatRow(row) {
      row.monthYear1.value = this.getValue(row.monthYear1.value);
      row.monthYear2.value = this.getValue(row.monthYear2.value);
      row.monthYear3.value = this.getValue(row.monthYear3.value);
      row.monthYear4.value = this.getValue(row.monthYear4.value);
      row.monthYear5.value = this.getValue(row.monthYear5.value);
      row.monthYear6.value = this.getValue(row.monthYear6.value);
      row.monthYear7.value = this.getValue(row.monthYear7.value);
      row.monthYear8.value = this.getValue(row.monthYear8.value);
      row.monthYear9.value = this.getValue(row.monthYear9.value);
      row.monthYear10.value = this.getValue(row.monthYear10.value);
      row.monthYear11.value = this.getValue(row.monthYear11.value);
      row.monthYear12.value = this.getValue(row.monthYear12.value);
      row.annual.value = this.getValue(row.annual.value);
      row.perUnit.value = this.getValue(row.perUnit.value);
      row.percentGpr.value = this.getValue(row.percentGpr.value);
      row.percentNaaSurvey.value = this.getValue(row.percentNaaSurvey.value);
      row.year2.value = this.getValue(row.year2.value);
      row.year3.value = this.getValue(row.year3.value);
      row.year4.value = this.getValue(row.year4.value);
      row.year5.value = this.getValue(row.year5.value);
      row.year6.value = this.getValue(row.year6.value);
    },

    async doCalculations() {
      console.log("doCalculations()");

      let grid = this.$store.state.longform;

      // Convert all inputs to floats.
      this.floatRow(grid.grossPotentialRent);
      this.floatRow(grid.gtol);
      this.floatRow(grid.newMoveInConcession);
      this.floatRow(grid.vacancy);
      this.floatRow(grid.badDebt);
      this.floatRow(grid.rentalIncome);
      this.floatRow(grid.otherIncome);
      this.floatRow(grid.totalIncomeDollar);
      this.floatRow(grid.totalIncomePercent);
      this.floatRow(grid.taxes);
      this.floatRow(grid.salariesAndPersonnel);
      this.floatRow(grid.repairAndMaintenance);
      this.floatRow(grid.managementFees);
      this.floatRow(grid.contractServices);
      this.floatRow(grid.utilities);
      this.floatRow(grid.administrative);
      this.floatRow(grid.insurance);
      this.floatRow(grid.marketing);
      for (let item of grid.customList) {
        this.floatRow(item.row);
      }
      this.floatRow(grid.carriedOver);
      this.floatRow(grid.totalOperatingExpenses);
      this.floatRow(grid.noi);
      this.floatRow(grid.utilityAndPayrollDeposits);
      this.floatRow(grid.mortgageInterest);
      this.floatRow(grid.principal);
      this.floatRow(grid.reserves);
      this.floatRow(grid.assetManagement);
      this.floatRow(grid.leadInvestorCompensation);
      this.floatRow(grid.netCash);
      this.floatRow(grid.beginningOccupancy);
      this.floatRow(grid.moveIns);
      this.floatRow(grid.moveOuts);
      this.floatRow(grid.endingOccupancyCount);
      this.floatRow(grid.endingOccupancyPercent);

      // Gross Potential Rent.
      grid.grossPotentialRent.annual.value =
        grid.grossPotentialRent.monthYear1.value +
        grid.grossPotentialRent.monthYear2.value +
        grid.grossPotentialRent.monthYear3.value +
        grid.grossPotentialRent.monthYear4.value +
        grid.grossPotentialRent.monthYear5.value +
        grid.grossPotentialRent.monthYear6.value +
        grid.grossPotentialRent.monthYear7.value +
        grid.grossPotentialRent.monthYear8.value +
        grid.grossPotentialRent.monthYear9.value +
        grid.grossPotentialRent.monthYear10.value +
        grid.grossPotentialRent.monthYear11.value +
        grid.grossPotentialRent.monthYear12.value;
      grid.grossPotentialRent.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.grossPotentialRent.annual.value / grid.inputs.unitCount;
      grid.grossPotentialRent.year2.value =
        grid.grossPotentialRent.monthYear12.value *
        12 *
        (1 + grid.inputs.incomeIncreaseYear2 / 100);
      grid.grossPotentialRent.year3.value =
        grid.grossPotentialRent.year2.value *
        (1 + grid.inputs.incomeIncreaseYear3 / 100);
      grid.grossPotentialRent.year4.value =
        grid.grossPotentialRent.year3.value *
        (1 + grid.inputs.incomeIncreaseYear4 / 100);
      grid.grossPotentialRent.year5.value =
        grid.grossPotentialRent.year4.value *
        (1 + grid.inputs.incomeIncreaseYear5 / 100);
      grid.grossPotentialRent.year6.value =
        grid.grossPotentialRent.year5.value *
        (1 + grid.inputs.incomeIncreaseYear6 / 100);

      // GTOL.
      grid.gtol.annual.value =
        grid.gtol.monthYear1.value +
        grid.gtol.monthYear2.value +
        grid.gtol.monthYear3.value +
        grid.gtol.monthYear4.value +
        grid.gtol.monthYear5.value +
        grid.gtol.monthYear6.value +
        grid.gtol.monthYear7.value +
        grid.gtol.monthYear8.value +
        grid.gtol.monthYear9.value +
        grid.gtol.monthYear10.value +
        grid.gtol.monthYear11.value +
        grid.gtol.monthYear12.value;
      grid.gtol.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.gtol.annual.value / grid.inputs.unitCount;

      // New Move-In Concession.
      grid.newMoveInConcession.annual.value =
        grid.newMoveInConcession.monthYear1.value +
        grid.newMoveInConcession.monthYear2.value +
        grid.newMoveInConcession.monthYear3.value +
        grid.newMoveInConcession.monthYear4.value +
        grid.newMoveInConcession.monthYear5.value +
        grid.newMoveInConcession.monthYear6.value +
        grid.newMoveInConcession.monthYear7.value +
        grid.newMoveInConcession.monthYear8.value +
        grid.newMoveInConcession.monthYear9.value +
        grid.newMoveInConcession.monthYear10.value +
        grid.newMoveInConcession.monthYear11.value +
        grid.newMoveInConcession.monthYear12.value;
      grid.newMoveInConcession.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.newMoveInConcession.annual.value / grid.inputs.unitCount;
      grid.newMoveInConcession.year2.value =
        grid.newMoveInConcession.monthYear12.value *
        12 *
        (1 + grid.inputs.incomeIncreaseYear2 / 100);
      grid.newMoveInConcession.year3.value =
        grid.newMoveInConcession.year2.value *
        (1 + grid.inputs.incomeIncreaseYear3 / 100);
      grid.newMoveInConcession.year4.value =
        grid.newMoveInConcession.year3.value *
        (1 + grid.inputs.incomeIncreaseYear4 / 100);
      grid.newMoveInConcession.year5.value =
        grid.newMoveInConcession.year4.value *
        (1 + grid.inputs.incomeIncreaseYear5 / 100);
      grid.newMoveInConcession.year6.value =
        grid.newMoveInConcession.year5.value *
        (1 + grid.inputs.incomeIncreaseYear6 / 100);

      // Vacancy.
      grid.vacancy.monthYear1.value =
        -1 *
        grid.grossPotentialRent.monthYear1.value *
        (1 - grid.endingOccupancyPercent.monthYear1.value / 100);
      grid.vacancy.monthYear2.value =
        -1 *
        grid.grossPotentialRent.monthYear2.value *
        (1 - grid.endingOccupancyPercent.monthYear2.value / 100);
      grid.vacancy.monthYear3.value =
        -1 *
        grid.grossPotentialRent.monthYear3.value *
        (1 - grid.endingOccupancyPercent.monthYear3.value / 100);
      grid.vacancy.monthYear4.value =
        -1 *
        grid.grossPotentialRent.monthYear4.value *
        (1 - grid.endingOccupancyPercent.monthYear4.value / 100);
      grid.vacancy.monthYear5.value =
        -1 *
        grid.grossPotentialRent.monthYear5.value *
        (1 - grid.endingOccupancyPercent.monthYear5.value / 100);
      grid.vacancy.monthYear6.value =
        -1 *
        grid.grossPotentialRent.monthYear6.value *
        (1 - grid.endingOccupancyPercent.monthYear6.value / 100);
      grid.vacancy.monthYear7.value =
        -1 *
        grid.grossPotentialRent.monthYear7.value *
        (1 - grid.endingOccupancyPercent.monthYear7.value / 100);
      grid.vacancy.monthYear8.value =
        -1 *
        grid.grossPotentialRent.monthYear8.value *
        (1 - grid.endingOccupancyPercent.monthYear8.value / 100);
      grid.vacancy.monthYear9.value =
        -1 *
        grid.grossPotentialRent.monthYear9.value *
        (1 - grid.endingOccupancyPercent.monthYear9.value / 100);
      grid.vacancy.monthYear10.value =
        -1 *
        grid.grossPotentialRent.monthYear10.value *
        (1 - grid.endingOccupancyPercent.monthYear10.value / 100);
      grid.vacancy.monthYear11.value =
        -1 *
        grid.grossPotentialRent.monthYear11.value *
        (1 - grid.endingOccupancyPercent.monthYear11.value / 100);
      grid.vacancy.monthYear12.value =
        -1 *
        grid.grossPotentialRent.monthYear12.value *
        (1 - grid.endingOccupancyPercent.monthYear12.value / 100);
      grid.vacancy.annual.value =
        grid.vacancy.monthYear1.value +
        grid.vacancy.monthYear2.value +
        grid.vacancy.monthYear3.value +
        grid.vacancy.monthYear4.value +
        grid.vacancy.monthYear5.value +
        grid.vacancy.monthYear6.value +
        grid.vacancy.monthYear7.value +
        grid.vacancy.monthYear8.value +
        grid.vacancy.monthYear9.value +
        grid.vacancy.monthYear10.value +
        grid.vacancy.monthYear11.value +
        grid.vacancy.monthYear12.value;
      grid.vacancy.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.vacancy.annual.value / grid.inputs.unitCount;
      grid.vacancy.percentGpr.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : (grid.vacancy.annual.value / grid.grossPotentialRent.annual.value) *
            -1 *
            100;
      grid.vacancy.percentNaaSurvey.value =
        grid.inputs.naaSurvey.lossesToVacancyPercentOfGpr;
      grid.vacancy.year2.value =
        grid.vacancy.monthYear12.value *
        12 *
        (1 + grid.inputs.incomeIncreaseYear2 / 100);
      grid.vacancy.year3.value =
        grid.vacancy.year2.value * (1 + grid.inputs.incomeIncreaseYear3 / 100);
      grid.vacancy.year4.value =
        grid.vacancy.year3.value * (1 + grid.inputs.incomeIncreaseYear4 / 100);
      grid.vacancy.year5.value =
        grid.vacancy.year4.value * (1 + grid.inputs.incomeIncreaseYear5 / 100);
      grid.vacancy.year6.value =
        grid.vacancy.year5.value * (1 + grid.inputs.incomeIncreaseYear6 / 100);

      // Bad Debt.
      grid.badDebt.annual.value =
        grid.badDebt.monthYear1.value +
        grid.badDebt.monthYear2.value +
        grid.badDebt.monthYear3.value +
        grid.badDebt.monthYear4.value +
        grid.badDebt.monthYear5.value +
        grid.badDebt.monthYear6.value +
        grid.badDebt.monthYear7.value +
        grid.badDebt.monthYear8.value +
        grid.badDebt.monthYear9.value +
        grid.badDebt.monthYear10.value +
        grid.badDebt.monthYear11.value +
        grid.badDebt.monthYear12.value;
      grid.badDebt.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.badDebt.annual.value / grid.inputs.unitCount;
      grid.badDebt.year2.value =
        grid.badDebt.monthYear12.value *
        12 *
        (1 + grid.inputs.incomeIncreaseYear2 / 100);
      grid.badDebt.year3.value =
        grid.badDebt.year2.value * (1 + grid.inputs.incomeIncreaseYear3 / 100);
      grid.badDebt.year4.value =
        grid.badDebt.year3.value * (1 + grid.inputs.incomeIncreaseYear4 / 100);
      grid.badDebt.year5.value =
        grid.badDebt.year4.value * (1 + grid.inputs.incomeIncreaseYear5 / 100);
      grid.badDebt.year6.value =
        grid.badDebt.year5.value * (1 + grid.inputs.incomeIncreaseYear6 / 100);

      // Rental Income.
      grid.rentalIncome.monthYear1.value =
        grid.grossPotentialRent.monthYear1.value +
        grid.gtol.monthYear1.value +
        grid.newMoveInConcession.monthYear1.value +
        grid.vacancy.monthYear1.value +
        grid.badDebt.monthYear1.value;
      grid.rentalIncome.monthYear2.value =
        grid.grossPotentialRent.monthYear2.value +
        grid.gtol.monthYear2.value +
        grid.newMoveInConcession.monthYear2.value +
        grid.vacancy.monthYear2.value +
        grid.badDebt.monthYear2.value;
      grid.rentalIncome.monthYear3.value =
        grid.grossPotentialRent.monthYear3.value +
        grid.gtol.monthYear3.value +
        grid.newMoveInConcession.monthYear3.value +
        grid.vacancy.monthYear3.value +
        grid.badDebt.monthYear3.value;
      grid.rentalIncome.monthYear4.value =
        grid.grossPotentialRent.monthYear4.value +
        grid.gtol.monthYear4.value +
        grid.newMoveInConcession.monthYear4.value +
        grid.vacancy.monthYear4.value +
        grid.badDebt.monthYear4.value;
      grid.rentalIncome.monthYear5.value =
        grid.grossPotentialRent.monthYear5.value +
        grid.gtol.monthYear5.value +
        grid.newMoveInConcession.monthYear5.value +
        grid.vacancy.monthYear5.value +
        grid.badDebt.monthYear5.value;
      grid.rentalIncome.monthYear6.value =
        grid.grossPotentialRent.monthYear6.value +
        grid.gtol.monthYear6.value +
        grid.newMoveInConcession.monthYear6.value +
        grid.vacancy.monthYear6.value +
        grid.badDebt.monthYear6.value;
      grid.rentalIncome.monthYear7.value =
        grid.grossPotentialRent.monthYear7.value +
        grid.gtol.monthYear7.value +
        grid.newMoveInConcession.monthYear7.value +
        grid.vacancy.monthYear7.value +
        grid.badDebt.monthYear7.value;
      grid.rentalIncome.monthYear8.value =
        grid.grossPotentialRent.monthYear8.value +
        grid.gtol.monthYear8.value +
        grid.newMoveInConcession.monthYear8.value +
        grid.vacancy.monthYear8.value +
        grid.badDebt.monthYear8.value;
      grid.rentalIncome.monthYear9.value =
        grid.grossPotentialRent.monthYear9.value +
        grid.gtol.monthYear9.value +
        grid.newMoveInConcession.monthYear9.value +
        grid.vacancy.monthYear9.value +
        grid.badDebt.monthYear9.value;
      grid.rentalIncome.monthYear10.value =
        grid.grossPotentialRent.monthYear10.value +
        grid.gtol.monthYear10.value +
        grid.newMoveInConcession.monthYear10.value +
        grid.vacancy.monthYear10.value +
        grid.badDebt.monthYear10.value;
      grid.rentalIncome.monthYear11.value =
        grid.grossPotentialRent.monthYear11.value +
        grid.gtol.monthYear11.value +
        grid.newMoveInConcession.monthYear11.value +
        grid.vacancy.monthYear11.value +
        grid.badDebt.monthYear11.value;
      grid.rentalIncome.monthYear12.value =
        grid.grossPotentialRent.monthYear12.value +
        grid.gtol.monthYear12.value +
        grid.newMoveInConcession.monthYear12.value +
        grid.vacancy.monthYear12.value +
        grid.badDebt.monthYear12.value;
      grid.rentalIncome.annual.value =
        grid.rentalIncome.monthYear1.value +
        grid.rentalIncome.monthYear2.value +
        grid.rentalIncome.monthYear3.value +
        grid.rentalIncome.monthYear4.value +
        grid.rentalIncome.monthYear5.value +
        grid.rentalIncome.monthYear6.value +
        grid.rentalIncome.monthYear7.value +
        grid.rentalIncome.monthYear8.value +
        grid.rentalIncome.monthYear9.value +
        grid.rentalIncome.monthYear10.value +
        grid.rentalIncome.monthYear11.value +
        grid.rentalIncome.monthYear12.value;
      grid.rentalIncome.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.rentalIncome.annual.value / grid.inputs.unitCount;
      grid.rentalIncome.percentGpr.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : (grid.rentalIncome.annual.value /
              grid.grossPotentialRent.annual.value) *
            -1;
      grid.rentalIncome.year2.value =
        grid.grossPotentialRent.year2.value +
        grid.gtol.year2.value +
        grid.newMoveInConcession.year2.value +
        grid.vacancy.year2.value +
        grid.badDebt.year2.value;
      grid.rentalIncome.year3.value =
        grid.grossPotentialRent.year3.value +
        grid.gtol.year3.value +
        grid.newMoveInConcession.year3.value +
        grid.vacancy.year3.value +
        grid.badDebt.year3.value;
      grid.rentalIncome.year4.value =
        grid.grossPotentialRent.year4.value +
        grid.gtol.year4.value +
        grid.newMoveInConcession.year4.value +
        grid.vacancy.year4.value +
        grid.badDebt.year4.value;
      grid.rentalIncome.year5.value =
        grid.grossPotentialRent.year5.value +
        grid.gtol.year5.value +
        grid.newMoveInConcession.year5.value +
        grid.vacancy.year5.value +
        grid.badDebt.year5.value;
      grid.rentalIncome.year6.value =
        grid.grossPotentialRent.year6.value +
        grid.gtol.year6.value +
        grid.newMoveInConcession.year6.value +
        grid.vacancy.year6.value +
        grid.badDebt.year6.value;

      // Other Income.
      grid.otherIncome.annual.value =
        grid.otherIncome.monthYear1.value +
        grid.otherIncome.monthYear2.value +
        grid.otherIncome.monthYear3.value +
        grid.otherIncome.monthYear4.value +
        grid.otherIncome.monthYear5.value +
        grid.otherIncome.monthYear6.value +
        grid.otherIncome.monthYear7.value +
        grid.otherIncome.monthYear8.value +
        grid.otherIncome.monthYear9.value +
        grid.otherIncome.monthYear10.value +
        grid.otherIncome.monthYear11.value +
        grid.otherIncome.monthYear12.value;
      grid.otherIncome.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.otherIncome.annual.value / grid.inputs.unitCount;
      grid.otherIncome.percentGpr.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : grid.otherIncome.annual.value /
            grid.grossPotentialRent.annual.value;
      grid.otherIncome.percentNaaSurvey.value =
        grid.inputs.naaSurvey.otherRevenuePercentOfGpr;
      grid.otherIncome.year4.value =
        grid.otherIncome.year3.value *
        (1 + grid.inputs.incomeIncreaseYear4 / 100);
      grid.otherIncome.year5.value =
        grid.otherIncome.year4.value *
        (1 + grid.inputs.incomeIncreaseYear5 / 100);
      grid.otherIncome.year6.value =
        grid.otherIncome.year5.value *
        (1 + grid.inputs.incomeIncreaseYear6 / 100);

      // Total Income Dollar.
      grid.totalIncomeDollar.monthYear1.value =
        grid.rentalIncome.monthYear1.value + grid.otherIncome.monthYear1.value;
      grid.totalIncomeDollar.monthYear2.value =
        grid.rentalIncome.monthYear2.value + grid.otherIncome.monthYear2.value;
      grid.totalIncomeDollar.monthYear3.value =
        grid.rentalIncome.monthYear3.value + grid.otherIncome.monthYear3.value;
      grid.totalIncomeDollar.monthYear4.value =
        grid.rentalIncome.monthYear4.value + grid.otherIncome.monthYear4.value;
      grid.totalIncomeDollar.monthYear5.value =
        grid.rentalIncome.monthYear5.value + grid.otherIncome.monthYear5.value;
      grid.totalIncomeDollar.monthYear6.value =
        grid.rentalIncome.monthYear6.value + grid.otherIncome.monthYear6.value;
      grid.totalIncomeDollar.monthYear7.value =
        grid.rentalIncome.monthYear7.value + grid.otherIncome.monthYear7.value;
      grid.totalIncomeDollar.monthYear8.value =
        grid.rentalIncome.monthYear8.value + grid.otherIncome.monthYear8.value;
      grid.totalIncomeDollar.monthYear9.value =
        grid.rentalIncome.monthYear9.value + grid.otherIncome.monthYear9.value;
      grid.totalIncomeDollar.monthYear10.value =
        grid.rentalIncome.monthYear10.value +
        grid.otherIncome.monthYear10.value;
      grid.totalIncomeDollar.monthYear11.value =
        grid.rentalIncome.monthYear11.value +
        grid.otherIncome.monthYear11.value;
      grid.totalIncomeDollar.monthYear12.value =
        grid.rentalIncome.monthYear12.value +
        grid.otherIncome.monthYear12.value;
      grid.totalIncomeDollar.annual.value =
        grid.totalIncomeDollar.monthYear1.value +
        grid.totalIncomeDollar.monthYear2.value +
        grid.totalIncomeDollar.monthYear3.value +
        grid.totalIncomeDollar.monthYear4.value +
        grid.totalIncomeDollar.monthYear5.value +
        grid.totalIncomeDollar.monthYear6.value +
        grid.totalIncomeDollar.monthYear7.value +
        grid.totalIncomeDollar.monthYear8.value +
        grid.totalIncomeDollar.monthYear9.value +
        grid.totalIncomeDollar.monthYear10.value +
        grid.totalIncomeDollar.monthYear11.value +
        grid.totalIncomeDollar.monthYear12.value;
      grid.totalIncomeDollar.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.totalIncomeDollar.annual.value / grid.inputs.unitCount;
      grid.totalIncomeDollar.percentGpr.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : (grid.totalIncomeDollar.annual.value /
              grid.grossPotentialRent.annual.value) *
            100;
      grid.totalIncomeDollar.percentNaaSurvey.value =
        grid.inputs.naaSurvey.totalRevenuePercentOfGpr;
      grid.totalIncomeDollar.year2.value =
        grid.rentalIncome.year2.value + grid.otherIncome.year2.value;
      grid.totalIncomeDollar.year3.value =
        grid.rentalIncome.year3.value + grid.otherIncome.year3.value;
      grid.totalIncomeDollar.year4.value =
        grid.rentalIncome.year4.value + grid.otherIncome.year4.value;
      grid.totalIncomeDollar.year5.value =
        grid.rentalIncome.year5.value + grid.otherIncome.year5.value;
      grid.totalIncomeDollar.year6.value =
        grid.rentalIncome.year6.value + grid.otherIncome.year6.value;

      // Total Income Percent.
      grid.totalIncomePercent.monthYear1.value =
        grid.grossPotentialRent.monthYear1.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear1.value /
              grid.grossPotentialRent.monthYear1.value) *
            100;
      grid.totalIncomePercent.monthYear2.value =
        grid.grossPotentialRent.monthYear2.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear2.value /
              grid.grossPotentialRent.monthYear2.value) *
            100;
      grid.totalIncomePercent.monthYear3.value =
        grid.grossPotentialRent.monthYear3.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear3.value /
              grid.grossPotentialRent.monthYear3.value) *
            100;
      grid.totalIncomePercent.monthYear4.value =
        grid.grossPotentialRent.monthYear4.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear4.value /
              grid.grossPotentialRent.monthYear4.value) *
            100;
      grid.totalIncomePercent.monthYear5.value =
        grid.grossPotentialRent.monthYear5.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear5.value /
              grid.grossPotentialRent.monthYear5.value) *
            100;
      grid.totalIncomePercent.monthYear6.value =
        grid.grossPotentialRent.monthYear6.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear6.value /
              grid.grossPotentialRent.monthYear6.value) *
            100;
      grid.totalIncomePercent.monthYear7.value =
        grid.grossPotentialRent.monthYear7.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear7.value /
              grid.grossPotentialRent.monthYear7.value) *
            100;
      grid.totalIncomePercent.monthYear8.value =
        grid.grossPotentialRent.monthYear8.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear8.value /
              grid.grossPotentialRent.monthYear8.value) *
            100;
      grid.totalIncomePercent.monthYear9.value =
        grid.grossPotentialRent.monthYear9.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear9.value /
              grid.grossPotentialRent.monthYear9.value) *
            100;
      grid.totalIncomePercent.monthYear10.value =
        grid.grossPotentialRent.monthYear10.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear10.value /
              grid.grossPotentialRent.monthYear10.value) *
            100;
      grid.totalIncomePercent.monthYear11.value =
        grid.grossPotentialRent.monthYear11.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear11.value /
              grid.grossPotentialRent.monthYear11.value) *
            100;
      grid.totalIncomePercent.monthYear12.value =
        grid.grossPotentialRent.monthYear12.value == 0
          ? 0
          : (grid.totalIncomeDollar.monthYear12.value /
              grid.grossPotentialRent.monthYear12.value) *
            100;
      grid.totalIncomePercent.annual.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : (grid.totalIncomeDollar.annual.value /
              grid.grossPotentialRent.annual.value) *
            100;
      grid.totalIncomePercent.perUnit.value =
        grid.grossPotentialRent.perUnit.value == 0
          ? 0
          : (grid.totalIncomeDollar.perUnit.value /
              grid.grossPotentialRent.perUnit.value) *
            100;
      grid.totalIncomePercent.year2.value =
        grid.grossPotentialRent.year2.value == 0
          ? 0
          : (grid.totalIncomeDollar.year2.value /
              grid.grossPotentialRent.year2.value) *
            100;
      grid.totalIncomePercent.year3.value =
        grid.grossPotentialRent.year3.value == 0
          ? 0
          : (grid.totalIncomeDollar.year3.value /
              grid.grossPotentialRent.year3.value) *
            100;
      grid.totalIncomePercent.year4.value =
        grid.grossPotentialRent.year4.value == 0
          ? 0
          : (grid.totalIncomeDollar.year4.value /
              grid.grossPotentialRent.year4.value) *
            100;
      grid.totalIncomePercent.year5.value =
        grid.grossPotentialRent.year5.value == 0
          ? 0
          : (grid.totalIncomeDollar.year5.value /
              grid.grossPotentialRent.year5.value) *
            100;
      grid.totalIncomePercent.year6.value =
        grid.grossPotentialRent.year6.value == 0
          ? 0
          : (grid.totalIncomeDollar.year6.value /
              grid.grossPotentialRent.year6.value) *
            100;

      // Operating Expenses.
      this.ExpenseTotals(grid.taxes, "Taxes");
      this.ExpenseTotals(grid.salariesAndPersonnel, "Salaries and Personnel");
      this.ExpenseTotals(grid.repairAndMaintenance, "Repair and Maintenance");
      this.ExpenseTotals(grid.managementFees, "Management Fees");
      this.ExpenseTotals(grid.contractServices, "Contract Services");
      this.ExpenseTotals(grid.utilities, "Utilities");
      this.ExpenseTotals(grid.administrative, "Administrative");
      this.ExpenseTotals(grid.insurance, "Insurance");
      this.ExpenseTotals(grid.marketing, "Marketing");
      for (let item of grid.customList) {
        this.ExpenseTotals(item.row, "");
      }
      this.ExpenseTotals(grid.carriedOver, "");

      // Total Operating Expenses.
      let customSum = grid.customList
        .map(v => v.row.monthYear1.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear1.value =
        grid.taxes.monthYear1.value +
        grid.salariesAndPersonnel.monthYear1.value +
        grid.repairAndMaintenance.monthYear1.value +
        grid.managementFees.monthYear1.value +
        grid.contractServices.monthYear1.value +
        grid.utilities.monthYear1.value +
        grid.administrative.monthYear1.value +
        grid.insurance.monthYear1.value +
        grid.marketing.monthYear1.value +
        customSum +
        grid.carriedOver.monthYear1.value;
      customSum = grid.customList
        .map(v => v.row.monthYear2.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear2.value =
        grid.taxes.monthYear2.value +
        grid.salariesAndPersonnel.monthYear2.value +
        grid.repairAndMaintenance.monthYear2.value +
        grid.managementFees.monthYear2.value +
        grid.contractServices.monthYear2.value +
        grid.utilities.monthYear2.value +
        grid.administrative.monthYear2.value +
        grid.insurance.monthYear2.value +
        grid.marketing.monthYear2.value +
        customSum +
        grid.carriedOver.monthYear2.value;
      customSum = grid.customList
        .map(v => v.row.monthYear3.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear3.value =
        grid.taxes.monthYear3.value +
        grid.salariesAndPersonnel.monthYear3.value +
        grid.repairAndMaintenance.monthYear3.value +
        grid.managementFees.monthYear3.value +
        grid.contractServices.monthYear3.value +
        grid.utilities.monthYear3.value +
        grid.administrative.monthYear3.value +
        grid.insurance.monthYear3.value +
        grid.marketing.monthYear3.value +
        customSum +
        grid.carriedOver.monthYear3.value;
      customSum = grid.customList
        .map(v => v.row.monthYear4.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear4.value =
        grid.taxes.monthYear4.value +
        grid.salariesAndPersonnel.monthYear4.value +
        grid.repairAndMaintenance.monthYear4.value +
        grid.managementFees.monthYear4.value +
        grid.contractServices.monthYear4.value +
        grid.utilities.monthYear4.value +
        grid.administrative.monthYear4.value +
        grid.insurance.monthYear4.value +
        grid.marketing.monthYear4.value +
        customSum +
        grid.carriedOver.monthYear4.value;
      customSum = grid.customList
        .map(v => v.row.monthYear5.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear5.value =
        grid.taxes.monthYear5.value +
        grid.salariesAndPersonnel.monthYear5.value +
        grid.repairAndMaintenance.monthYear5.value +
        grid.managementFees.monthYear5.value +
        grid.contractServices.monthYear5.value +
        grid.utilities.monthYear5.value +
        grid.administrative.monthYear5.value +
        grid.insurance.monthYear5.value +
        grid.marketing.monthYear5.value +
        customSum +
        grid.carriedOver.monthYear5.value;
      customSum = grid.customList
        .map(v => v.row.monthYear6.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear6.value =
        grid.taxes.monthYear6.value +
        grid.salariesAndPersonnel.monthYear6.value +
        grid.repairAndMaintenance.monthYear6.value +
        grid.managementFees.monthYear6.value +
        grid.contractServices.monthYear6.value +
        grid.utilities.monthYear6.value +
        grid.administrative.monthYear6.value +
        grid.insurance.monthYear6.value +
        grid.marketing.monthYear6.value +
        customSum +
        grid.carriedOver.monthYear6.value;
      customSum = grid.customList
        .map(v => v.row.monthYear7.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear7.value =
        grid.taxes.monthYear7.value +
        grid.salariesAndPersonnel.monthYear7.value +
        grid.repairAndMaintenance.monthYear7.value +
        grid.managementFees.monthYear7.value +
        grid.contractServices.monthYear7.value +
        grid.utilities.monthYear7.value +
        grid.administrative.monthYear7.value +
        grid.insurance.monthYear7.value +
        grid.marketing.monthYear7.value +
        customSum +
        grid.carriedOver.monthYear7.value;
      customSum = grid.customList
        .map(v => v.row.monthYear8.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear8.value =
        grid.taxes.monthYear8.value +
        grid.salariesAndPersonnel.monthYear8.value +
        grid.repairAndMaintenance.monthYear8.value +
        grid.managementFees.monthYear8.value +
        grid.contractServices.monthYear8.value +
        grid.utilities.monthYear8.value +
        grid.administrative.monthYear8.value +
        grid.insurance.monthYear8.value +
        grid.marketing.monthYear8.value +
        customSum +
        grid.carriedOver.monthYear8.value;
      customSum = grid.customList
        .map(v => v.row.monthYear9.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear9.value =
        grid.taxes.monthYear9.value +
        grid.salariesAndPersonnel.monthYear9.value +
        grid.repairAndMaintenance.monthYear9.value +
        grid.managementFees.monthYear9.value +
        grid.contractServices.monthYear9.value +
        grid.utilities.monthYear9.value +
        grid.administrative.monthYear9.value +
        grid.insurance.monthYear9.value +
        grid.marketing.monthYear9.value +
        customSum +
        grid.carriedOver.monthYear9.value;
      customSum = grid.customList
        .map(v => v.row.monthYear10.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear10.value =
        grid.taxes.monthYear10.value +
        grid.salariesAndPersonnel.monthYear10.value +
        grid.repairAndMaintenance.monthYear10.value +
        grid.managementFees.monthYear10.value +
        grid.contractServices.monthYear10.value +
        grid.utilities.monthYear10.value +
        grid.administrative.monthYear10.value +
        grid.insurance.monthYear10.value +
        grid.marketing.monthYear10.value +
        customSum +
        grid.carriedOver.monthYear10.value;
      customSum = grid.customList
        .map(v => v.row.monthYear11.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear11.value =
        grid.taxes.monthYear11.value +
        grid.salariesAndPersonnel.monthYear11.value +
        grid.repairAndMaintenance.monthYear11.value +
        grid.managementFees.monthYear11.value +
        grid.contractServices.monthYear11.value +
        grid.utilities.monthYear11.value +
        grid.administrative.monthYear11.value +
        grid.insurance.monthYear11.value +
        grid.marketing.monthYear11.value +
        customSum +
        grid.carriedOver.monthYear11.value;
      customSum = grid.customList
        .map(v => v.row.monthYear12.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.monthYear12.value =
        grid.taxes.monthYear12.value +
        grid.salariesAndPersonnel.monthYear12.value +
        grid.repairAndMaintenance.monthYear12.value +
        grid.managementFees.monthYear12.value +
        grid.contractServices.monthYear12.value +
        grid.utilities.monthYear12.value +
        grid.administrative.monthYear12.value +
        grid.insurance.monthYear12.value +
        grid.marketing.monthYear12.value +
        customSum +
        grid.carriedOver.monthYear12.value;
      grid.totalOperatingExpenses.annual.value =
        grid.totalOperatingExpenses.monthYear1.value +
        grid.totalOperatingExpenses.monthYear2.value +
        grid.totalOperatingExpenses.monthYear3.value +
        grid.totalOperatingExpenses.monthYear4.value +
        grid.totalOperatingExpenses.monthYear5.value +
        grid.totalOperatingExpenses.monthYear6.value +
        grid.totalOperatingExpenses.monthYear7.value +
        grid.totalOperatingExpenses.monthYear8.value +
        grid.totalOperatingExpenses.monthYear9.value +
        grid.totalOperatingExpenses.monthYear10.value +
        grid.totalOperatingExpenses.monthYear11.value +
        grid.totalOperatingExpenses.monthYear12.value;
      grid.totalOperatingExpenses.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.totalOperatingExpenses.annual.value / grid.inputs.unitCount;
      grid.totalOperatingExpenses.percentGpr.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : (grid.totalOperatingExpenses.annual.value /
              grid.grossPotentialRent.annual.value) *
            100;
      grid.totalOperatingExpenses.percentNaaSurvey.value =
        grid.inputs.naaSurvey.totalOperatingExpensesPercentOfGpr;
      customSum = grid.customList
        .map(v => v.row.year2.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.year2.value =
        grid.taxes.year2.value +
        grid.salariesAndPersonnel.year2.value +
        grid.repairAndMaintenance.year2.value +
        grid.managementFees.year2.value +
        grid.contractServices.year2.value +
        grid.utilities.year2.value +
        grid.administrative.year2.value +
        grid.insurance.year2.value +
        grid.marketing.year2.value +
        customSum +
        grid.carriedOver.year2.value;
      customSum = grid.customList
        .map(v => v.row.year3.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.year3.value =
        grid.taxes.year3.value +
        grid.salariesAndPersonnel.year3.value +
        grid.repairAndMaintenance.year3.value +
        grid.managementFees.year3.value +
        grid.contractServices.year3.value +
        grid.utilities.year3.value +
        grid.administrative.year3.value +
        grid.insurance.year3.value +
        grid.marketing.year3.value +
        customSum +
        grid.carriedOver.year3.value;
      customSum = grid.customList
        .map(v => v.row.year4.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.year4.value =
        grid.taxes.year4.value +
        grid.salariesAndPersonnel.year4.value +
        grid.repairAndMaintenance.year4.value +
        grid.managementFees.year4.value +
        grid.contractServices.year4.value +
        grid.utilities.year4.value +
        grid.administrative.year4.value +
        grid.insurance.year4.value +
        grid.marketing.year4.value +
        customSum +
        grid.carriedOver.year4.value;
      customSum = grid.customList
        .map(v => v.row.year5.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.year5.value =
        grid.taxes.year5.value +
        grid.salariesAndPersonnel.year5.value +
        grid.repairAndMaintenance.year5.value +
        grid.managementFees.year5.value +
        grid.contractServices.year5.value +
        grid.utilities.year5.value +
        grid.administrative.year5.value +
        grid.insurance.year5.value +
        grid.marketing.year5.value +
        customSum +
        grid.carriedOver.year5.value;
      customSum = grid.customList
        .map(v => v.row.year6.value)
        .reduce((acc, currentValue) => acc + currentValue, 0);
      grid.totalOperatingExpenses.year6.value =
        grid.taxes.year6.value +
        grid.salariesAndPersonnel.year6.value +
        grid.repairAndMaintenance.year6.value +
        grid.managementFees.year6.value +
        grid.contractServices.year6.value +
        grid.utilities.year6.value +
        grid.administrative.year6.value +
        grid.insurance.year6.value +
        grid.marketing.year6.value +
        customSum +
        grid.carriedOver.year6.value;

      // NOI.
      grid.noi.monthYear1.value =
        grid.totalIncomeDollar.monthYear1.value -
        grid.totalOperatingExpenses.monthYear1.value;
      grid.noi.monthYear2.value =
        grid.totalIncomeDollar.monthYear2.value -
        grid.totalOperatingExpenses.monthYear2.value;
      grid.noi.monthYear3.value =
        grid.totalIncomeDollar.monthYear3.value -
        grid.totalOperatingExpenses.monthYear3.value;
      grid.noi.monthYear4.value =
        grid.totalIncomeDollar.monthYear4.value -
        grid.totalOperatingExpenses.monthYear4.value;
      grid.noi.monthYear5.value =
        grid.totalIncomeDollar.monthYear5.value -
        grid.totalOperatingExpenses.monthYear5.value;
      grid.noi.monthYear6.value =
        grid.totalIncomeDollar.monthYear6.value -
        grid.totalOperatingExpenses.monthYear6.value;
      grid.noi.monthYear7.value =
        grid.totalIncomeDollar.monthYear7.value -
        grid.totalOperatingExpenses.monthYear7.value;
      grid.noi.monthYear8.value =
        grid.totalIncomeDollar.monthYear8.value -
        grid.totalOperatingExpenses.monthYear8.value;
      grid.noi.monthYear9.value =
        grid.totalIncomeDollar.monthYear9.value -
        grid.totalOperatingExpenses.monthYear9.value;
      grid.noi.monthYear10.value =
        grid.totalIncomeDollar.monthYear10.value -
        grid.totalOperatingExpenses.monthYear10.value;
      grid.noi.monthYear11.value =
        grid.totalIncomeDollar.monthYear11.value -
        grid.totalOperatingExpenses.monthYear11.value;
      grid.noi.monthYear12.value =
        grid.totalIncomeDollar.monthYear12.value -
        grid.totalOperatingExpenses.monthYear12.value;
      grid.noi.annual.value =
        grid.noi.monthYear1.value +
        grid.noi.monthYear2.value +
        grid.noi.monthYear3.value +
        grid.noi.monthYear4.value +
        grid.noi.monthYear5.value +
        grid.noi.monthYear6.value +
        grid.noi.monthYear7.value +
        grid.noi.monthYear8.value +
        grid.noi.monthYear9.value +
        grid.noi.monthYear10.value +
        grid.noi.monthYear11.value +
        grid.noi.monthYear12.value;
      grid.noi.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.noi.annual.value / grid.inputs.unitCount;
      grid.noi.percentGpr.value =
        grid.grossPotentialRent.annual.value == 0
          ? 0
          : (grid.noi.annual.value / grid.grossPotentialRent.annual.value) *
            100;
      grid.noi.percentNaaSurvey.value =
        grid.inputs.naaSurvey.netOperatingIncomePercentOfGpr;
      grid.noi.year2.value =
        grid.totalIncomeDollar.year2.value -
        grid.totalOperatingExpenses.year2.value;
      grid.noi.year3.value =
        grid.totalIncomeDollar.year3.value -
        grid.totalOperatingExpenses.year3.value;
      grid.noi.year4.value =
        grid.totalIncomeDollar.year4.value -
        grid.totalOperatingExpenses.year4.value;
      grid.noi.year5.value =
        grid.totalIncomeDollar.year5.value -
        grid.totalOperatingExpenses.year5.value;
      grid.noi.year6.value =
        grid.totalIncomeDollar.year6.value -
        grid.totalOperatingExpenses.year6.value;

      // Utility and Payroll Deposits.
      grid.utilityAndPayrollDeposits.annual.value =
        grid.utilityAndPayrollDeposits.monthYear1.value +
        grid.utilityAndPayrollDeposits.monthYear2.value +
        grid.utilityAndPayrollDeposits.monthYear3.value +
        grid.utilityAndPayrollDeposits.monthYear4.value +
        grid.utilityAndPayrollDeposits.monthYear5.value +
        grid.utilityAndPayrollDeposits.monthYear6.value +
        grid.utilityAndPayrollDeposits.monthYear7.value +
        grid.utilityAndPayrollDeposits.monthYear8.value +
        grid.utilityAndPayrollDeposits.monthYear9.value +
        grid.utilityAndPayrollDeposits.monthYear10.value +
        grid.utilityAndPayrollDeposits.monthYear11.value +
        grid.utilityAndPayrollDeposits.monthYear12.value;
      grid.utilityAndPayrollDeposits.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.utilityAndPayrollDeposits.annual.value / grid.inputs.unitCount;

      // Mortgage Interest.
      grid.mortgageInterest.monthYear1.value = this.MortgageValue(1, 1, 1);
      grid.mortgageInterest.monthYear2.value = this.MortgageValue(1, 2, 2);
      grid.mortgageInterest.monthYear3.value = this.MortgageValue(1, 3, 3);
      grid.mortgageInterest.monthYear4.value = this.MortgageValue(1, 4, 4);
      grid.mortgageInterest.monthYear5.value = this.MortgageValue(1, 5, 5);
      grid.mortgageInterest.monthYear6.value = this.MortgageValue(1, 6, 6);
      grid.mortgageInterest.monthYear7.value = this.MortgageValue(1, 7, 7);
      grid.mortgageInterest.monthYear8.value = this.MortgageValue(1, 8, 8);
      grid.mortgageInterest.monthYear9.value = this.MortgageValue(1, 9, 9);
      grid.mortgageInterest.monthYear10.value = this.MortgageValue(1, 10, 10);
      grid.mortgageInterest.monthYear11.value = this.MortgageValue(1, 11, 11);
      grid.mortgageInterest.monthYear12.value = this.MortgageValue(1, 12, 12);
      grid.mortgageInterest.annual.value =
        grid.mortgageInterest.monthYear1.value +
        grid.mortgageInterest.monthYear2.value +
        grid.mortgageInterest.monthYear3.value +
        grid.mortgageInterest.monthYear4.value +
        grid.mortgageInterest.monthYear5.value +
        grid.mortgageInterest.monthYear6.value +
        grid.mortgageInterest.monthYear7.value +
        grid.mortgageInterest.monthYear8.value +
        grid.mortgageInterest.monthYear9.value +
        grid.mortgageInterest.monthYear10.value +
        grid.mortgageInterest.monthYear11.value +
        grid.mortgageInterest.monthYear12.value;
      grid.mortgageInterest.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.mortgageInterest.annual.value / grid.inputs.unitCount;
      grid.mortgageInterest.year2.value = this.MortgageValue(1, 13, 24);
      grid.mortgageInterest.year3.value = this.MortgageValue(1, 25, 36);
      grid.mortgageInterest.year4.value = this.MortgageValue(1, 37, 48);
      grid.mortgageInterest.year5.value = this.MortgageValue(1, 49, 60);
      grid.mortgageInterest.year6.value = this.MortgageValue(1, 61, 72);

      // Principal.
      grid.principal.monthYear1.value = this.MortgageValue(0, 1, 1);
      grid.principal.monthYear2.value = this.MortgageValue(0, 2, 2);
      grid.principal.monthYear3.value = this.MortgageValue(0, 3, 3);
      grid.principal.monthYear4.value = this.MortgageValue(0, 4, 4);
      grid.principal.monthYear5.value = this.MortgageValue(0, 5, 5);
      grid.principal.monthYear6.value = this.MortgageValue(0, 6, 6);
      grid.principal.monthYear7.value = this.MortgageValue(0, 7, 7);
      grid.principal.monthYear8.value = this.MortgageValue(0, 8, 8);
      grid.principal.monthYear9.value = this.MortgageValue(0, 9, 9);
      grid.principal.monthYear10.value = this.MortgageValue(0, 10, 10);
      grid.principal.monthYear11.value = this.MortgageValue(0, 11, 11);
      grid.principal.monthYear12.value = this.MortgageValue(0, 12, 12);
      grid.principal.annual.value =
        grid.principal.monthYear1.value +
        grid.principal.monthYear2.value +
        grid.principal.monthYear3.value +
        grid.principal.monthYear4.value +
        grid.principal.monthYear5.value +
        grid.principal.monthYear6.value +
        grid.principal.monthYear7.value +
        grid.principal.monthYear8.value +
        grid.principal.monthYear9.value +
        grid.principal.monthYear10.value +
        grid.principal.monthYear11.value +
        grid.principal.monthYear12.value;
      grid.principal.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.principal.annual.value / grid.inputs.unitCount;
      grid.principal.year2.value = this.MortgageValue(0, 13, 24);
      grid.principal.year3.value = this.MortgageValue(0, 25, 36);
      grid.principal.year4.value = this.MortgageValue(0, 37, 48);
      grid.principal.year5.value = this.MortgageValue(0, 49, 60);
      grid.principal.year6.value = this.MortgageValue(0, 61, 72);

      // Reserves.
      grid.reserves.annual.value =
        grid.reserves.monthYear1.value +
        grid.reserves.monthYear2.value +
        grid.reserves.monthYear3.value +
        grid.reserves.monthYear4.value +
        grid.reserves.monthYear5.value +
        grid.reserves.monthYear6.value +
        grid.reserves.monthYear7.value +
        grid.reserves.monthYear8.value +
        grid.reserves.monthYear9.value +
        grid.reserves.monthYear10.value +
        grid.reserves.monthYear11.value +
        grid.reserves.monthYear12.value;
      grid.reserves.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.reserves.annual.value / grid.inputs.unitCount;

      // Asset Management.
      grid.assetManagement.monthYear1.value =
        (grid.totalIncomeDollar.monthYear1.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear2.value =
        (grid.totalIncomeDollar.monthYear2.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear3.value =
        (grid.totalIncomeDollar.monthYear3.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear4.value =
        (grid.totalIncomeDollar.monthYear4.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear5.value =
        (grid.totalIncomeDollar.monthYear5.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear6.value =
        (grid.totalIncomeDollar.monthYear6.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear7.value =
        (grid.totalIncomeDollar.monthYear7.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear8.value =
        (grid.totalIncomeDollar.monthYear8.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear9.value =
        (grid.totalIncomeDollar.monthYear9.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear10.value =
        (grid.totalIncomeDollar.monthYear10.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear11.value =
        (grid.totalIncomeDollar.monthYear11.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.monthYear12.value =
        (grid.totalIncomeDollar.monthYear12.value *
          grid.inputs.assetManagementPercent) /
        100;
      grid.assetManagement.annual.value =
        grid.assetManagement.monthYear1.value +
        grid.assetManagement.monthYear2.value +
        grid.assetManagement.monthYear3.value +
        grid.assetManagement.monthYear4.value +
        grid.assetManagement.monthYear5.value +
        grid.assetManagement.monthYear6.value +
        grid.assetManagement.monthYear7.value +
        grid.assetManagement.monthYear8.value +
        grid.assetManagement.monthYear9.value +
        grid.assetManagement.monthYear10.value +
        grid.assetManagement.monthYear11.value +
        grid.assetManagement.monthYear12.value;
      grid.assetManagement.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.assetManagement.annual.value / grid.inputs.unitCount;
      grid.assetManagement.year2.value =
        grid.assetManagement.monthYear12.value *
        12 *
        (1 + grid.inputs.expenseIncreaseYear2 / 100);
      grid.assetManagement.year3.value =
        grid.assetManagement.year2.value *
        (1 + grid.inputs.expenseIncreaseYear3 / 100);
      grid.assetManagement.year4.value =
        grid.assetManagement.year3.value *
        (1 + grid.inputs.expenseIncreaseYear4 / 100);
      grid.assetManagement.year5.value =
        grid.assetManagement.year4.value *
        (1 + grid.inputs.expenseIncreaseYear5 / 100);
      grid.assetManagement.year6.value =
        grid.assetManagement.year5.value *
        (1 + grid.inputs.expenseIncreaseYear6 / 100);

      // Lead Investor Compensation.
      grid.leadInvestorCompensation.monthYear1.value =
        (grid.noi.monthYear1.value -
          (grid.mortgageInterest.monthYear1.value +
            grid.principal.monthYear1.value +
            grid.reserves.monthYear1.value +
            grid.assetManagement.monthYear1.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear2.value =
        (grid.noi.monthYear2.value -
          (grid.mortgageInterest.monthYear2.value +
            grid.principal.monthYear2.value +
            grid.reserves.monthYear2.value +
            grid.assetManagement.monthYear2.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear3.value =
        (grid.noi.monthYear3.value -
          (grid.mortgageInterest.monthYear3.value +
            grid.principal.monthYear3.value +
            grid.reserves.monthYear3.value +
            grid.assetManagement.monthYear3.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear4.value =
        (grid.noi.monthYear4.value -
          (grid.mortgageInterest.monthYear4.value +
            grid.principal.monthYear4.value +
            grid.reserves.monthYear4.value +
            grid.assetManagement.monthYear4.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear5.value =
        (grid.noi.monthYear5.value -
          (grid.mortgageInterest.monthYear5.value +
            grid.principal.monthYear5.value +
            grid.reserves.monthYear5.value +
            grid.assetManagement.monthYear5.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear6.value =
        (grid.noi.monthYear6.value -
          (grid.mortgageInterest.monthYear6.value +
            grid.principal.monthYear6.value +
            grid.reserves.monthYear6.value +
            grid.assetManagement.monthYear6.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear7.value =
        (grid.noi.monthYear7.value -
          (grid.mortgageInterest.monthYear7.value +
            grid.principal.monthYear7.value +
            grid.reserves.monthYear7.value +
            grid.assetManagement.monthYear7.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear8.value =
        (grid.noi.monthYear8.value -
          (grid.mortgageInterest.monthYear8.value +
            grid.principal.monthYear8.value +
            grid.reserves.monthYear8.value +
            grid.assetManagement.monthYear8.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear9.value =
        (grid.noi.monthYear9.value -
          (grid.mortgageInterest.monthYear9.value +
            grid.principal.monthYear9.value +
            grid.reserves.monthYear9.value +
            grid.assetManagement.monthYear9.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear10.value =
        (grid.noi.monthYear10.value -
          (grid.mortgageInterest.monthYear10.value +
            grid.principal.monthYear10.value +
            grid.reserves.monthYear10.value +
            grid.assetManagement.monthYear10.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear11.value =
        (grid.noi.monthYear11.value -
          (grid.mortgageInterest.monthYear11.value +
            grid.principal.monthYear11.value +
            grid.reserves.monthYear11.value +
            grid.assetManagement.monthYear11.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.monthYear12.value =
        (grid.noi.monthYear12.value -
          (grid.mortgageInterest.monthYear12.value +
            grid.principal.monthYear12.value +
            grid.reserves.monthYear12.value +
            grid.assetManagement.monthYear12.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.annual.value =
        grid.leadInvestorCompensation.monthYear1.value +
        grid.leadInvestorCompensation.monthYear2.value +
        grid.leadInvestorCompensation.monthYear3.value +
        grid.leadInvestorCompensation.monthYear4.value +
        grid.leadInvestorCompensation.monthYear5.value +
        grid.leadInvestorCompensation.monthYear6.value +
        grid.leadInvestorCompensation.monthYear7.value +
        grid.leadInvestorCompensation.monthYear8.value +
        grid.leadInvestorCompensation.monthYear9.value +
        grid.leadInvestorCompensation.monthYear10.value +
        grid.leadInvestorCompensation.monthYear11.value +
        grid.leadInvestorCompensation.monthYear12.value;
      grid.leadInvestorCompensation.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.leadInvestorCompensation.annual.value / grid.inputs.unitCount;
      grid.leadInvestorCompensation.year2.value =
        (grid.noi.year2.value -
          (grid.mortgageInterest.year2.value +
            grid.principal.year2.value +
            grid.reserves.year2.value +
            grid.assetManagement.year2.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.year3.value =
        (grid.noi.year3.value -
          (grid.mortgageInterest.year3.value +
            grid.principal.year3.value +
            grid.reserves.year3.value +
            grid.assetManagement.year3.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.year4.value =
        (grid.noi.year4.value -
          (grid.mortgageInterest.year4.value +
            grid.principal.year4.value +
            grid.reserves.year4.value +
            grid.assetManagement.year4.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.year5.value =
        (grid.noi.year5.value -
          (grid.mortgageInterest.year5.value +
            grid.principal.year5.value +
            grid.reserves.year5.value +
            grid.assetManagement.year5.value)) *
        (grid.inputs.leadInvestorCompensation / 100);
      grid.leadInvestorCompensation.year6.value =
        (grid.noi.year6.value -
          (grid.mortgageInterest.year6.value +
            grid.principal.year6.value +
            grid.reserves.year6.value +
            grid.assetManagement.year6.value)) *
        (grid.inputs.leadInvestorCompensation / 100);

      // Net Cash.
      grid.netCash.monthYear1.value =
        grid.noi.monthYear1.value -
        (grid.utilityAndPayrollDeposits.monthYear1.value +
          grid.mortgageInterest.monthYear1.value +
          grid.principal.monthYear1.value +
          grid.reserves.monthYear1.value +
          grid.assetManagement.monthYear1.value +
          grid.leadInvestorCompensation.monthYear1.value);
      grid.netCash.monthYear2.value =
        grid.noi.monthYear2.value -
        (grid.utilityAndPayrollDeposits.monthYear2.value +
          grid.mortgageInterest.monthYear2.value +
          grid.principal.monthYear2.value +
          grid.reserves.monthYear2.value +
          grid.assetManagement.monthYear2.value +
          grid.leadInvestorCompensation.monthYear2.value);
      grid.netCash.monthYear3.value =
        grid.noi.monthYear3.value -
        (grid.utilityAndPayrollDeposits.monthYear3.value +
          grid.mortgageInterest.monthYear3.value +
          grid.principal.monthYear3.value +
          grid.reserves.monthYear3.value +
          grid.assetManagement.monthYear3.value +
          grid.leadInvestorCompensation.monthYear3.value);
      grid.netCash.monthYear4.value =
        grid.noi.monthYear4.value -
        (grid.utilityAndPayrollDeposits.monthYear4.value +
          grid.mortgageInterest.monthYear4.value +
          grid.principal.monthYear4.value +
          grid.reserves.monthYear4.value +
          grid.assetManagement.monthYear4.value +
          grid.leadInvestorCompensation.monthYear4.value);
      grid.netCash.monthYear5.value =
        grid.noi.monthYear5.value -
        (grid.utilityAndPayrollDeposits.monthYear5.value +
          grid.mortgageInterest.monthYear5.value +
          grid.principal.monthYear5.value +
          grid.reserves.monthYear5.value +
          grid.assetManagement.monthYear5.value +
          grid.leadInvestorCompensation.monthYear5.value);
      grid.netCash.monthYear6.value =
        grid.noi.monthYear6.value -
        (grid.utilityAndPayrollDeposits.monthYear6.value +
          grid.mortgageInterest.monthYear6.value +
          grid.principal.monthYear6.value +
          grid.reserves.monthYear6.value +
          grid.assetManagement.monthYear6.value +
          grid.leadInvestorCompensation.monthYear6.value);
      grid.netCash.monthYear7.value =
        grid.noi.monthYear7.value -
        (grid.utilityAndPayrollDeposits.monthYear7.value +
          grid.mortgageInterest.monthYear7.value +
          grid.principal.monthYear7.value +
          grid.reserves.monthYear7.value +
          grid.assetManagement.monthYear7.value +
          grid.leadInvestorCompensation.monthYear7.value);
      grid.netCash.monthYear8.value =
        grid.noi.monthYear8.value -
        (grid.utilityAndPayrollDeposits.monthYear8.value +
          grid.mortgageInterest.monthYear8.value +
          grid.principal.monthYear8.value +
          grid.reserves.monthYear8.value +
          grid.assetManagement.monthYear8.value +
          grid.leadInvestorCompensation.monthYear8.value);
      grid.netCash.monthYear9.value =
        grid.noi.monthYear9.value -
        (grid.utilityAndPayrollDeposits.monthYear9.value +
          grid.mortgageInterest.monthYear9.value +
          grid.principal.monthYear9.value +
          grid.reserves.monthYear9.value +
          grid.assetManagement.monthYear9.value +
          grid.leadInvestorCompensation.monthYear9.value);
      grid.netCash.monthYear10.value =
        grid.noi.monthYear10.value -
        (grid.utilityAndPayrollDeposits.monthYear10.value +
          grid.mortgageInterest.monthYear10.value +
          grid.principal.monthYear10.value +
          grid.reserves.monthYear10.value +
          grid.assetManagement.monthYear10.value +
          grid.leadInvestorCompensation.monthYear10.value);
      grid.netCash.monthYear11.value =
        grid.noi.monthYear11.value -
        (grid.utilityAndPayrollDeposits.monthYear11.value +
          grid.mortgageInterest.monthYear11.value +
          grid.principal.monthYear11.value +
          grid.reserves.monthYear11.value +
          grid.assetManagement.monthYear11.value +
          grid.leadInvestorCompensation.monthYear11.value);
      grid.netCash.monthYear12.value =
        grid.noi.monthYear12.value -
        (grid.utilityAndPayrollDeposits.monthYear12.value +
          grid.mortgageInterest.monthYear12.value +
          grid.principal.monthYear12.value +
          grid.reserves.monthYear12.value +
          grid.assetManagement.monthYear12.value +
          grid.leadInvestorCompensation.monthYear12.value);
      grid.netCash.annual.value =
        grid.netCash.monthYear1.value +
        grid.netCash.monthYear2.value +
        grid.netCash.monthYear3.value +
        grid.netCash.monthYear4.value +
        grid.netCash.monthYear5.value +
        grid.netCash.monthYear6.value +
        grid.netCash.monthYear7.value +
        grid.netCash.monthYear8.value +
        grid.netCash.monthYear9.value +
        grid.netCash.monthYear10.value +
        grid.netCash.monthYear11.value +
        grid.netCash.monthYear12.value;
      grid.netCash.perUnit.value =
        grid.inputs.unitCount == 0
          ? 0
          : grid.netCash.annual.value / grid.inputs.unitCount;
      grid.netCash.year2.value =
        grid.noi.year2.value -
        (grid.utilityAndPayrollDeposits.year2.value +
          grid.mortgageInterest.year2.value +
          grid.principal.year2.value +
          grid.reserves.year2.value +
          grid.assetManagement.year2.value +
          grid.leadInvestorCompensation.year2.value);
      grid.netCash.year3.value =
        grid.noi.year3.value -
        (grid.utilityAndPayrollDeposits.year3.value +
          grid.mortgageInterest.year3.value +
          grid.principal.year3.value +
          grid.reserves.year3.value +
          grid.assetManagement.year3.value +
          grid.leadInvestorCompensation.year3.value);
      grid.netCash.year4.value =
        grid.noi.year4.value -
        (grid.utilityAndPayrollDeposits.year4.value +
          grid.mortgageInterest.year4.value +
          grid.principal.year4.value +
          grid.reserves.year4.value +
          grid.assetManagement.year4.value +
          grid.leadInvestorCompensation.year4.value);
      grid.netCash.year5.value =
        grid.noi.year5.value -
        (grid.utilityAndPayrollDeposits.year5.value +
          grid.mortgageInterest.year5.value +
          grid.principal.year5.value +
          grid.reserves.year5.value +
          grid.assetManagement.year5.value +
          grid.leadInvestorCompensation.year5.value);
      grid.netCash.year6.value =
        grid.noi.year6.value -
        (grid.utilityAndPayrollDeposits.year6.value +
          grid.mortgageInterest.year6.value +
          grid.principal.year6.value +
          grid.reserves.year6.value +
          grid.assetManagement.year6.value +
          grid.leadInvestorCompensation.year6.value);

      let i = 0;
      for (i = 0; i < 12; i++) {
        // Beginning Occupancy.
        grid.beginningOccupancy.monthYear2.value =
          grid.endingOccupancyCount.monthYear1.value;
        grid.beginningOccupancy.monthYear3.value =
          grid.endingOccupancyCount.monthYear2.value;
        grid.beginningOccupancy.monthYear4.value =
          grid.endingOccupancyCount.monthYear3.value;
        grid.beginningOccupancy.monthYear5.value =
          grid.endingOccupancyCount.monthYear4.value;
        grid.beginningOccupancy.monthYear6.value =
          grid.endingOccupancyCount.monthYear5.value;
        grid.beginningOccupancy.monthYear7.value =
          grid.endingOccupancyCount.monthYear6.value;
        grid.beginningOccupancy.monthYear8.value =
          grid.endingOccupancyCount.monthYear7.value;
        grid.beginningOccupancy.monthYear9.value =
          grid.endingOccupancyCount.monthYear8.value;
        grid.beginningOccupancy.monthYear10.value =
          grid.endingOccupancyCount.monthYear9.value;
        grid.beginningOccupancy.monthYear11.value =
          grid.endingOccupancyCount.monthYear10.value;
        grid.beginningOccupancy.monthYear12.value =
          grid.endingOccupancyCount.monthYear11.value;

        // Ending Occupancy Count.
        grid.endingOccupancyCount.monthYear1.value =
          grid.beginningOccupancy.monthYear1.value +
          grid.moveIns.monthYear1.value -
          grid.moveOuts.monthYear1.value;
        grid.endingOccupancyCount.monthYear2.value =
          grid.beginningOccupancy.monthYear2.value +
          grid.moveIns.monthYear2.value -
          grid.moveOuts.monthYear2.value;
        grid.endingOccupancyCount.monthYear3.value =
          grid.beginningOccupancy.monthYear3.value +
          grid.moveIns.monthYear3.value -
          grid.moveOuts.monthYear3.value;
        grid.endingOccupancyCount.monthYear4.value =
          grid.beginningOccupancy.monthYear4.value +
          grid.moveIns.monthYear4.value -
          grid.moveOuts.monthYear4.value;
        grid.endingOccupancyCount.monthYear5.value =
          grid.beginningOccupancy.monthYear5.value +
          grid.moveIns.monthYear5.value -
          grid.moveOuts.monthYear5.value;
        grid.endingOccupancyCount.monthYear6.value =
          grid.beginningOccupancy.monthYear6.value +
          grid.moveIns.monthYear6.value -
          grid.moveOuts.monthYear6.value;
        grid.endingOccupancyCount.monthYear7.value =
          grid.beginningOccupancy.monthYear7.value +
          grid.moveIns.monthYear7.value -
          grid.moveOuts.monthYear7.value;
        grid.endingOccupancyCount.monthYear8.value =
          grid.beginningOccupancy.monthYear8.value +
          grid.moveIns.monthYear8.value -
          grid.moveOuts.monthYear8.value;
        grid.endingOccupancyCount.monthYear9.value =
          grid.beginningOccupancy.monthYear9.value +
          grid.moveIns.monthYear9.value -
          grid.moveOuts.monthYear9.value;
        grid.endingOccupancyCount.monthYear10.value =
          grid.beginningOccupancy.monthYear10.value +
          grid.moveIns.monthYear10.value -
          grid.moveOuts.monthYear10.value;
        grid.endingOccupancyCount.monthYear11.value =
          grid.beginningOccupancy.monthYear11.value +
          grid.moveIns.monthYear11.value -
          grid.moveOuts.monthYear11.value;
        grid.endingOccupancyCount.monthYear12.value =
          grid.beginningOccupancy.monthYear12.value +
          grid.moveIns.monthYear12.value -
          grid.moveOuts.monthYear12.value;

        // Ending Occupancy Percent.
        grid.endingOccupancyPercent.monthYear1.value =
          (grid.endingOccupancyCount.monthYear1.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear2.value =
          (grid.endingOccupancyCount.monthYear2.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear3.value =
          (grid.endingOccupancyCount.monthYear3.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear4.value =
          (grid.endingOccupancyCount.monthYear4.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear5.value =
          (grid.endingOccupancyCount.monthYear5.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear6.value =
          (grid.endingOccupancyCount.monthYear6.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear7.value =
          (grid.endingOccupancyCount.monthYear7.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear8.value =
          (grid.endingOccupancyCount.monthYear8.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear9.value =
          (grid.endingOccupancyCount.monthYear9.value / grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear10.value =
          (grid.endingOccupancyCount.monthYear10.value /
            grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear11.value =
          (grid.endingOccupancyCount.monthYear11.value /
            grid.inputs.unitCount) *
          100;
        grid.endingOccupancyPercent.monthYear12.value =
          (grid.endingOccupancyCount.monthYear12.value /
            grid.inputs.unitCount) *
          100;
      }
    },

    ExpenseTotals(row, label) {
      row.annual.value =
        row.monthYear1.value +
        row.monthYear2.value +
        row.monthYear3.value +
        row.monthYear4.value +
        row.monthYear5.value +
        row.monthYear6.value +
        row.monthYear7.value +
        row.monthYear8.value +
        row.monthYear9.value +
        row.monthYear10.value +
        row.monthYear11.value +
        row.monthYear12.value;
      row.perUnit.value =
        this.$store.state.longform.inputs.unitCount == 0
          ? 0
          : row.annual.value / this.$store.state.longform.inputs.unitCount;
      row.percentGpr.value =
        this.$store.state.longform.grossPotentialRent.annual.value == 0
          ? 0
          : (row.annual.value /
              this.$store.state.longform.grossPotentialRent.annual.value) *
            100;
      let naaSurveyPercent = 0;
      let naaSurvey = this.$store.state.longform.inputs.naaSurvey;
      if (label == "Taxes") naaSurveyPercent = naaSurvey.taxesPercentOfGpr;
      if (label == "Salaries and Personnel")
        naaSurveyPercent = naaSurvey.salariesAndPersonnelPercentOfGpr;
      if (label == "Repair and Maintenance")
        naaSurveyPercent = naaSurvey.repairAndMaintenancePercentOfGpr;
      if (label == "Management Fees")
        naaSurveyPercent = naaSurvey.managementFeesPercentOfGpr;
      if (label == "Contract Services")
        naaSurveyPercent = naaSurvey.contractServicesPercentOfGpr;
      if (label == "Utilities")
        naaSurveyPercent = naaSurvey.utilitiesPercentOfGpr;
      if (label == "Administrative")
        naaSurveyPercent = naaSurvey.adminitrativePercentOfGpr;
      if (label == "Insurance")
        naaSurveyPercent = naaSurvey.insurancePercentOfGpr;
      if (label == "Marketing")
        naaSurveyPercent = naaSurvey.marketingPercentOfGpr;
      row.percentNaaSurvey.value = naaSurveyPercent;

      // If this is the taxes row, just calculate year 4, 5, and 6. Year 2 and 3 are
      // input by the user.
      if (label != "Taxes") {
        row.year2.value =
          row.monthYear12.value *
          12 *
          (1 + this.$store.state.longform.inputs.expenseIncreaseYear2 / 100);
        row.year3.value =
          row.year2.value *
          (1 + this.$store.state.longform.inputs.expenseIncreaseYear3 / 100);
      }
      row.year4.value =
        row.year3.value *
        (1 + this.$store.state.longform.inputs.expenseIncreaseYear4 / 100);
      row.year5.value =
        row.year4.value *
        (1 + this.$store.state.longform.inputs.expenseIncreaseYear5 / 100);
      row.year6.value =
        row.year5.value *
        (1 + this.$store.state.longform.inputs.expenseIncreaseYear6 / 100);
    },

    MortgageValue(isInterest, startMonth, endMonth) {
      let inputs = this.$store.state.longform.inputs;
      if (inputs.loanAmount == 0) return 0;
      // Intermediate values.
      let monthlyInterestRate = inputs.interestRatePercent / 100 / 12;
      let numberOfPayments = Math.round(inputs.termInYears * 12, 0);
      let monthlyPayment =
        -1 *
        Financial.PMT(
          monthlyInterestRate,
          numberOfPayments - inputs.interestOnlyPeriodInYears * 12,
          inputs.loanAmount,
          0,
          0
        );
      monthlyPayment = Math.round(monthlyPayment * 100) / 100;
      let balance = inputs.loanAmount;
      let mortgageInterest = 0;
      let principalReduction = 0;
      for (let payNumber = 1; payNumber < 30 * 12; payNumber++) {
        // Calculate the interest.
        let interest = Math.round(monthlyInterestRate * balance * 100, 2) / 100;
        // Calculate the scheduled payment.
        let scheduledPayment = 0;
        if (payNumber <= inputs.interestOnlyPeriodInYears * 12)
          scheduledPayment = interest;
        else if (
          payNumber >
          Math.round((1 + monthlyInterestRate) * balance * 100, 2) / 100
        )
          scheduledPayment =
            Math.round((1 + monthlyInterestRate) * balance * 100, 2) / 100;
        else scheduledPayment = monthlyPayment;
        // Calculate the principal.
        let principal = scheduledPayment - interest;
        // Calculate the new balance.
        balance = balance - principal;
        if (payNumber >= startMonth && payNumber <= endMonth) {
          mortgageInterest += interest;
          principalReduction += principal;
        }
      }
      if (isInterest == 1) return mortgageInterest;
      else return principalReduction;
    }
  },

  async mounted() {
    console.log("MonthNames=", this.$store.state.longform.monthNames);
    console.log(
      "mounted()",
      this.$route.params.property_id,
      this.$route.params.longform_id
    );
    var propertyId = this.$route.params.property_id;
    var longformId = this.$route.params.longform_id;
    this.$store.dispatch("getProperty", propertyId);
    await this.$store.dispatch("getLongform", { propertyId, longformId });
    let needToSave = false;
    if (this.$store.state.longform.netCash.year2.value == 0) needToSave = true;
    this.calculate();
    if (needToSave == true) await this.updateLongform();
  },

  beforeRouteLeave(to, from, next) {
    if (this.changed) {
      this.$buefy.dialog.confirm({
        cancelText: "Stay",
        confirmText: "Leave Without Saving",
        message:
          "Your evaluation has unsaved changes. Do you really want to leave?",
        type: "is-danger",
        onConfirm: () => {
          this.changed = false;
          next();
        },
        onCancel: () => {
          next(false);
        }
      });
    } else next();
  }
};
</script>

<style>
.specialdiv {
  max-width: auto;
  max-height: 40em;
  overflow: scroll;
  position: relative;
}

table {
  position: relative;
  border-collapse: collapse;
}

td,
th {
  padding: 0.25em;
}

th {
  z-index: 1;
}

thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
  background: #fff;
  color: #fff;
  z-index: 1000;
}

thead th:first-child {
  left: 0;
  z-index: 1;
}

tbody th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  left: 0;
  background: #fff;
  border-right: 1px solid #ccc;
}
table {
  font-size: 90%;
}
input[type="number"] {
  text-align: right;
}
input[type="text"] {
  text-align: left;
}
td.operating-expenses-columns-header {
  font-weight: bold;
  font-size: 120%;
  text-align: center;
}
td.operating-expenses-column-header {
  font-weight: bold;
  font-size: 100%;
  text-align: right;
}
td.align-left {
  text-align: left;
}
td.align-right {
  text-align: right;
}
td.align-center {
  text-align: center;
}
th.right-border td.right-border {
  border-right: 2px solid #000;
}
td.column-header {
  font-weight: bold;
  font-size: 120%;
  vertical-align: bottom;
}
tr.subline {
  font-weight: lighter;
  font-size: 90%;
}
tr.subtotal1 {
  font-weight: bold;
  font-size: 90%;
  border-top: 2px solid;
  border-bottom: 2px solid;
}
tr.subtotal2 {
  font-weight: bold;
  font-size: 120%;
  border-top: 2px solid;
  border-bottom: 2px solid;
}
tr.subtotal3 {
  font-weight: bold;
  outline: 2px solid;
  font-size: 120%;
  text-transform: uppercase;
}
.disclaimer {
  font-size: 80%;
  font-weight: bold;
}
.textarea {
  width: 250px;
  min-height: 50px;
  height: auto;
  border: 2px solid rgba(63, 63, 63, 1);
}
.notices .snackbar {
  min-height: 2.5em;
  min-width: 1em;
}
</style>
